import template from './logout.html';
import controller from './logout.controller';
import './logout.styl';

let logoutComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default logoutComponent;



// WEBPACK FOOTER //
// ./client/app/components/logout/logout.component.js